import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { string, arrayOf, object } from 'prop-types';
import ListingItem from 'components/filtered-listing/items/ListingItem';

export default function TileContainer({ items, tileType }) {
    return (
        <ReactCSSTransitionGroup
            component="table"
            className="fl-tile-container"
            transitionName="fade-in-out"
            transitionAppear={true}
            transitionAppearTimeout={200}
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
        >
            <tr className="c-content-tile">
                <th className="guid">
                    Docket
                </th>
                <th className="date">
                    Date
                </th>
                <th className="job">
                    Job
                </th>
                <th className="costcode">
                    Cost Code
                </th>
                <th className="equipment">
                    Equipment
                </th>
                <th className="material">
                    Material
                </th>
                <th className="foreman">
                    Foreman
                </th>
                <th className="site">
                    Site
                </th>
                <th className="status">
                    Status
                </th>
            </tr>
            {items.map((item, index) => (
                <ListingItem
                    /* eslint-disable react/no-array-index-key */
                    // @NOTE - ideally the key should be item.guid but this creates a jumpy effect with React transition group, so we will
                    //         keep using index for now until we find a better solution
                    key={index}
                    item={item}
                    tileType={tileType}
                    /* eslint-enable react/no-array-index-key */
                />
            ))}
        </ReactCSSTransitionGroup>
    );
}

TileContainer.propTypes = {
    items: arrayOf(object).isRequired,
    tileType: string.isRequired
};
